"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
var _Location = _interopRequireDefault(require("../../../../molecules/Location"));
var _Call = _interopRequireDefault(require("../../../../molecules/Call"));
var _Email = _interopRequireDefault(require("../../../../molecules/Email"));
var _HoursOfOperation = _interopRequireDefault(require("../../../../molecules/HoursOfOperation"));
var SimpleBody = function SimpleBody(props) {
  var _props$contactInforma = props.contactInformation,
    address = _props$contactInforma.address,
    phoneNumber = _props$contactInforma.phoneNumber,
    email = _props$contactInforma.email,
    pages = props.pages,
    hours = props.hours,
    ctas = props.ctas,
    bodyColor = props.bodyColor,
    locationClassName = props.locationClassName,
    phoneNumberClassName = props.phoneNumberClassName,
    emailClassName = props.emailClassName,
    hoursClassName = props.hoursClassName;
  var columns = hours.length === 0 ? 0 : 1 + pages.length + 1;
  var WorkHoursColumn = function WorkHoursColumn() {
    return hours.length === 0 ? null : /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      computer: 4,
      tablet: 5
    }, /*#__PURE__*/_react["default"].createElement(_HoursOfOperation["default"], {
      hours: hours,
      displayOption: "grouped",
      className: hoursClassName
    }));
  };
  var CtasSection = function CtasSection() {
    return ctas.length === 3 ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      width: 2,
      only: "tablet computer"
    }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      width: 3,
      verticalAlign: "middle"
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
      primary: true,
      as: "a",
      href: "#".concat(ctas[0].link),
      size: "medium",
      fluid: true
    }, ctas[0].text)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      width: 1,
      only: "tablet computer"
    }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      width: 4
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
      primary: true,
      as: "a",
      href: "#".concat(ctas[1].link),
      size: "big",
      fluid: true
    }, ctas[1].text)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      width: 1,
      only: "tablet computer"
    }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      width: 3,
      verticalAlign: "middle"
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
      primary: true,
      as: "a",
      href: "#".concat(ctas[2].link),
      size: "medium",
      fluid: true
    }, ctas[2].text)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      width: 2,
      only: "tablet computer"
    })) : ctas.length === 2 && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      width: 3,
      only: "tablet computer"
    }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      width: 4,
      verticalAlign: "middle"
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
      primary: true,
      as: "a",
      href: "#".concat(ctas[0].link),
      size: "medium",
      fluid: true
    }, ctas[0].text)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      width: 2,
      only: "tablet computer"
    }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      width: 4
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
      primary: true,
      as: "a",
      href: "#".concat(ctas[1].link),
      size: "big",
      fluid: true
    }, ctas[1].text)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      width: 3,
      only: "tablet computer"
    }));
  };
  var LocationColumn = function LocationColumn() {
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      computer: 4,
      tablet: 5,
      textAlign: "center"
    }, /*#__PURE__*/_react["default"].createElement(_Location["default"], {
      address: address,
      showIcon: true,
      className: locationClassName
    }), /*#__PURE__*/_react["default"].createElement(_Call["default"], {
      phoneNumber: phoneNumber,
      showIcon: true,
      className: phoneNumberClassName
    }), email && /*#__PURE__*/_react["default"].createElement(_Email["default"], {
      email: email,
      showIcon: true,
      className: emailClassName
    }));
  };
  var MainSection = function MainSection() {
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, {
      columns: columns
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      width: 1,
      only: "tablet computer"
    }), /*#__PURE__*/_react["default"].createElement(LocationColumn, null), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      computer: 6,
      tablet: 4
    }), /*#__PURE__*/_react["default"].createElement(WorkHoursColumn, null), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      width: 1,
      only: "tablet computer"
    }));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: bodyColor,
      paddingTop: '3em',
      paddingBottom: '2em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
    stackable: true
  }, /*#__PURE__*/_react["default"].createElement(MainSection, null), /*#__PURE__*/_react["default"].createElement(CtasSection, null)));
};
SimpleBody.propTypes = {
  bodyColor: _propTypes["default"].string.isRequired,
  locationClassName: _propTypes["default"].string,
  phoneNumberClassName: _propTypes["default"].string,
  emailClassName: _propTypes["default"].string,
  hoursClassName: _propTypes["default"].string
};
SimpleBody.defaultProps = {
  locationClassName: 'footer-location-info',
  phoneNumberClassName: 'footer-phone-number',
  emailClassName: 'footer-email-address',
  hoursClassName: 'footer-hoo'
};
var _default = SimpleBody;
exports["default"] = _default;